<template>
    <li class="nav-item nav-profile dropdown">
        <a class="d-flex align-items-center nav-link dropdown-toggle mr-0"
           id="profileDropdown"
           href="#"
           data-toggle="dropdown"
           aria-expanded="false">
            <div class="nav-profile-text">
                <p class="mb-0 text-black text-right">
                    {{ user.full_name || user.name }} <br>
                    <span class="text-secondary font-size-90 d-block mt-1">
                        {{ user.role }}
                    </span>
                </p>
            </div>
            <app-avatar :title="user.full_name || user.name"
                        avatar-class="avatars-w-40"
                        :img="user.img || user.profile_picture"
                        alt-text="image"/>
        </a>
        <div class="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="profileDropdown">
            <div class="dropdown-item profile">
                <app-avatar :title="user.full_name || user.name"
                            avatar-class="avatars-w-50"
                            :img="user.img || user.profile_picture"
                            alt-text="image"/>
                <div class="nav-profile-text font-size-default ml-2">
                    <p class="my-0 text-black">{{ user.full_name || user.name }}</p>
                    <span class="text-secondary font-size-90">{{ user.role }}</span>
                </div>
            </div>
            <div class="dropdown-divider"/>
            <a class="dropdown-item" 
               v-for="(item, index) in data" 
               :href="item.url" 
               :key="index"
               @click="handleItemClick(item, $event)">
                <app-icon class="mr-3" :name="item.optionIcon"/>
                {{ item.optionName }}
            </a>
        </div>
    </li>
</template>

<script>
    export default {
        name: "ProfileDropdown",
        props: {
            user: {
                type: Object,
                required: true
            },
            data: {
                type: Array,
                required: true
            }
        },
        methods: {
            handleItemClick(item, event) {
                // Check if this is a logout link (URL contains 'logout')
                if (item.url && item.url.includes('logout')) {
                    event.preventDefault();
                    this.handleLogout(item.url);
                    return false;
                }
                // For other items, allow default link behavior
            },
            handleLogout(logoutUrl) {
                // Create a form and submit it via POST
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = logoutUrl;
                
                // Add CSRF token
                const csrfToken = document.querySelector('meta[name="csrf-token"]');
                if (csrfToken) {
                    const csrfInput = document.createElement('input');
                    csrfInput.type = 'hidden';
                    csrfInput.name = '_token';
                    csrfInput.value = csrfToken.getAttribute('content');
                    form.appendChild(csrfInput);
                }
                
                // Append form to body and submit
                document.body.appendChild(form);
                form.submit();
            }
        }
    }
</script>
